'use strict';

/* global $ */
/* global _ */
/* global Backbone */
/* global Marionette */

import * as InputCheck from '../../utils/input_check';

class CountInput extends Marionette.View {
    getTemplate(){
        let self = this;
        switch(self.getOption('show_type')){
        case 'number_int':
            return _.template('<input type="number" value="<%- value %>" min="0" step="1" />');
        default:
            return _.template('<input type="number" value="<%- value %>" min="0" step="any" />');
        }
    }
    tagName() {
        return 'span';
    }
    ui() {
        return {
            'input': 'input'
        };
    }
    modelEvents() {
        return {
            'on:value:changed' : 'setCount'
        };
    }
    events() {
        return {
            'change @ui.input': 'changeCount',
        };
    }
    onRender() {
        let self = this;
        self._detectType();

        if(self.getOption('class')){
            self.$el.addClass(self.getOption('class'));
        }

        let input = self.getUI('input');
        switch(self.getOption('show_type')){
        case 'number_int':
            input
                .on('keydown', function(e){ return InputCheck.integerInput(this, e); })
                .inputarrow({
                    min: self.getOption('min') || 0,
                    no_max: ((self.getOption('max')) ? false : true),
                    max: self.getOption('max'),
                    step: self.getOption('step') || 1
                });
            break;
        default:
            input
                .on('keydown', function(e){ return InputCheck.floatInput(this, e); })
                .on('change', function(){
                    let vl = parseFloat(this.value, 10);
                    if(vl < 0){
                        vl *= -1;
                    }
                    this.value = vl;
                });
        }
    }
    changeCount() {
        let self = this;
        let count = self.getCount();
        let field = self.getOption('field') || 'value';

        self.model.set(field, count);
    }
    setCount(model_field){
        let self = this;
        let field = self.getOption('field') || 'value';
        if(model_field === field){
            let $input = self.getUI('input');
            $input.val(self.model.get(field));
        }
    }
    getCount(){
        let self = this;
        let $input = self.getUI('input');
        return $input.val();
    }
    templateContext(){
        let self = this;
        let field = self.getOption('field') || 'value';
        return {
            value: self.model.get(field)
        };
    }
    _detectType() {
        let self = this;
        self.$el.removeClass('simple-input')
                .removeClass('arrow-input');

        switch(self.getOption('show_type')){
        case 'number_int':
            self.$el.addClass('arrow-input');
            break;
        default:
            self.$el.addClass('simple-input');

        }
    }
}

class ValueInput extends Marionette.View {
    getTemplate(){
        return _.template('<input type="text" value="<%- value %>" disabled />');
    }
    tagName() {
        return 'span';
    }
    ui() {
        return {
            'input': 'input'
        };
    }
    onRender() {
        let self = this;

        self.$el.addClass('only-input');
    }
    getCount(){
        let self = this;
        let $input = self.getUI('input');
        return $input.val();
    }
    templateContext(){
        let self = this;
        let field = self.getOption('field') || 'value';
        return {
            value: self.model.get(field)
        };
    }
}

class SelectInput extends Marionette.View {
    template(){
        return _.template('<select></select>');
    }
    ui() {
        return {
            'select': 'select'
        };
    }
    events(){
        return {
            'change @ui.select': '_change'
        };
    }
    onRender(){
        let self = this;

        let $select = self.getUI('select');

        let value = self.model.get('value') || undefined;

        let values = self.getOption('values');
        _.each(values, function(item){
            let option = $(document.createElement('option'))
                                .attr({
                                    value: item
                                })
                                .text(item)
                                .appendTo($select);
            if((!_.isUndefined(value)) && (value == item)){
                option.prop('selected', true);
            }
        });

        $select.selectBox({ mobile: true,
                            menuTransition: 'fade',
                            menuSpeed: 'fast' });

    }
    _change(){
        let self = this;
        // console.log('_change');
        let value = self.getValue();
        let field = self.getOption('field') || 'value';
        // console.log('value');
        self.model.set(field, value);
    }
    getValue(){
        let self = this;
        let $select = self.getUI('select');
        // let value = $select.val();
        let value = $select.selectBox('value');
        return value;
    }
    setValue(){
        let self = this;
        let $select = self.getUI('select');
        let field = self.getOption('field') || 'value';
        // $select.val(self.model.get('value'));
        $select.selectBox('value', self.model.get(field));
    }
}

export {
    CountInput,
    SelectInput,
    ValueInput
};

